module.exports = __webpack_public_path__ + "img/prosuctivity-122.8317cdcd.jpg";